module.exports = __webpack_public_path__ + "static/20200804_154538-acc79e21c92d0eb8f77d99c01f77045d.jpg";